import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import BlueIcon from "../assets/Blue.png";
import SearchIcon from "@mui/icons-material/Search";
import ShareIcon from "@mui/icons-material/Share";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import api from "../services/api";
import auth from "../services/auth";
import Loading from "../components/Loading";
import onDate from "../utils/Date";

export default function Home() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log(documents);

  const onSearch = (value) => {
    console.log(value);
  };

  useEffect(() => {
    setLoading(true);
    api
      .get("documents-allbyuser", { headers: auth.token() })
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          console.log(response.data.data);
          setDocuments(response.data.data);
        }
      });
  }, []);

  const handleDownload = (id, name) => {
    api
      .get(`documents/${id}`, { headers: auth.token(), responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${name}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: "background.paper",
          pt: 8,
          pb: 6,
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              backgroundImage: `url(${BlueIcon})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center",
              height: 180,
              width: "100%",
              mb: 4,
            }}
          />
          <Box>
            <FormControl fullWidth variant="outlined">
              <InputLabel htmlFor="password">Pesquisar</InputLabel>
              <OutlinedInput
                onChange={(ev) => onSearch(ev.target.value)}
                type="text"
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                }
                label="Pesquisar"
              />
            </FormControl>
          </Box>
        </Container>
      </Box>
      <Container maxWidth="lg">
        {/* End hero unit */}
        {loading ? (
          <Loading height="30vh" />
        ) : documents.length === 0 ? (
          <Typography variant="h2" textAlign="center">
            Nenhum documento cadastrado
          </Typography>
        ) : (
          <Grid container spacing={8}>
            {documents.map((document) => (
              <Grid item key={document.id} xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    bgcolor: "primary.main",
                    height: 300,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      sx={{ color: "neutral.main" }}
                      gutterBottom
                      variant="h4"
                      component="h1"
                    >
                      {document.name}
                    </Typography>
                    <Typography sx={{ color: "neutral.main" }}>
                      Emissor: {document.creator.name}
                    </Typography>
                    <Typography sx={{ color: "neutral.main" }}>
                      Data da Emissão:{" "}
                      {document.created_at
                        ? onDate(document.created_at)
                        : "00/00/0000"}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      size="small"
                      endIcon={<ShareIcon color="primary" />}
                      color="neutral"
                      variant="contained"
                    >
                      <Typography color="primary">Compartilhar</Typography>
                    </Button>
                    <Button
                      size="small"
                      endIcon={<CloudDownloadIcon color="primary" />}
                      color="neutral"
                      variant="contained"
                      onClick={() => handleDownload(document.id, document.name)}
                    >
                      <Typography color="primary">Baixar</Typography>
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </>
  );
}
